import {loadMetadata} from "../../api/thredds/metadata.api";
import moment from "moment"

const state = {
  metadata: {}
};

const mutations = {
  setMetadata(state, data){
    state.metadata = data;
  },
};

const actions = {
  async loadMetadata( {commit}, payload ){
    const {LAYERS} = payload;
    const response = await loadMetadata(LAYERS);
    let date = response.data.nearestTimeIso
    date = moment(date, 'YYYY-MM-DDTHH:mm:ss.000Z').tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm')
    commit('setMetadata', date)
  },
};

const getters = {
  metadata: (state) => state.metadata,
};
export default {
  state,
  mutations,
  actions,
  getters
}
